var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"menu",staticClass:"action-menu"},[_c('base-button',{attrs:{"size":"sm"},on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_vm._t("trigger",function(){return [_vm._v("⋮")]})],2),(_vm.isOpen)?_c('div',{staticClass:"action-menu__dropdown"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }